module.exports = __webpack_public_path__ + "img/raymond_james.396aedf0.png";